<template>
  <Sparkline v-if="trend.length" :data="values" :options="options" v-b-tooltip.hover.right  v-model="tooltip" :title="title" />
</template>
<script>
import {get, sortBy, sumBy} from 'lodash'
import Sparkline from '@/components/Sparkline'
const outcome_days = 21

export default {
  name: 'Delta',
  components: { Sparkline },
  props: ['page'],

  data: () => {
    return {
      tooltip: {},
    }
  },
  computed: {
    trend() {
      return get(this.page, 'trend', [])
    },
    title() {
      if(this.tooltip.index !== undefined && this.trend[this.tooltip.index]) {
        const date = new Date(this.sorted[this.tooltip.index].date)
        const val = this.tooltip.value || 0
        const dateStr = date.toLocaleDateString()
        if(val > 0) {
          return `${dateStr}: +${val}% over forecast`
        } else if(val < 0) {
          return `${dateStr}: ${val}% under forecast`
        }
        return `${dateStr}: ${val}%`
      }
      return null
    },
    sorted() {
      return sortBy(this.trend, 'date')
    },
    values() {
      return this.sorted.map(e => this.$options.filters.delta(e.clicks, e.forecast))
    },
    options() {
      const trend = this.average(get(this.page, 'experiment.trend', this.page.trend))
      return {endColor: trend > 0.05 ? 'green' : trend < -0.05 ? 'red' : 'black'}
    },
  },
  methods: {
    daysUntilOutcome(page) {
      const latest = get(page, 'trend[0].date') ? new Date(get(page, 'trend[0].date') + 'Z') : new Date()

      const trendDays = this.$options.filters.daysSince(page.approved_at, latest)
      const daysLeft = outcome_days - trendDays
      return daysLeft > 0 ? daysLeft : 0
    },
    hasOutcome(page) {
      return get(page, 'experiment.is_winner') !== null
    },
    // Used by ResultsTable
    average(trend) {
      const clicks = sumBy(trend, 'clicks')
      const forecast = sumBy(trend, 'forecast')
      return this.$options.filters.delta(clicks, forecast)
    },
  }
}
</script>